import React from "react";
import { observer } from "mobx-react";
import cn from "classnames";
import format from "@app/lib/format";

import { CitationType } from "@app/state/model/citation";
import { ReportDocumentSection } from "@app/constants";
import documentStore from "@app/state/store/report-document/document";

const LITERATURE_TYPES = new Set([
    CitationType.CUSTOM,
    CitationType.DUE,
    CitationType.SOTA,
    CitationType.PREVIOUS_DUE,
    CitationType.PREVIOUS_SOTA,
]);

const INTERNAL_TYPES = new Set([CitationType.DOCUMENT]);

const { REFERENCES_VARIANT } = ReportDocumentSection.CUSTOM_OBJECT;

function filterRefsByVariant(refs, variant) {
    if (variant === REFERENCES_VARIANT.LITERATURE) {
        return refs.filter((ref) => ref.data && LITERATURE_TYPES.has(ref.data.type));
    }
    if (variant === REFERENCES_VARIANT.INTERNAL) {
        return refs.filter((ref) => ref.data && INTERNAL_TYPES.has(ref.data.type));
    }
    return refs;
}

const ReferencesList = ({ referencesToShow }) => {
    if (!referencesToShow.length) {
        return <div className="empty">No references used in document</div>;
    }

    return (
        <div>
            {referencesToShow.map((ref) => {
                return (
                    <div
                        key={ref.id}
                        className={cn("list-entry", { invalid: !ref.file })}
                        dangerouslySetInnerHTML={{
                            __html: format.formatTitle(ref.formatted),
                        }}
                    ></div>
                );
            })}
        </div>
    );
};

const References = observer(({ metadata }) => {
    const variant = metadata?.variant || REFERENCES_VARIANT.ALL;
    const references = filterRefsByVariant(documentStore.refs, variant);

    return (
        <div className="content-list">
            <ReferencesList referencesToShow={references} />
        </div>
    );
});

export default References;
